import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';
import VideoPlayer from './components/video/video';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

//import './css/index.css';
//import './css/header.css';

export default class SupportStreams extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			
			streams: [],
			/*websites: [],
			ips: [],
			ip: '',*/
		};
		/*this.getWebsites = this.getWebsites.bind(this);
		this.updateWebsite = this.updateWebsite.bind(this);
		this.ipaddressAdd = this.ipaddressAdd.bind(this);
		this.ipaddressRemove = this.ipaddressRemove.bind(this);*/
		this.loadStreams = this.loadStreams.bind(this);
		//this.restart = this.restart.bind(this);
	
	
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		//this.getWebsites();

		

		//this.setState({status: true});
		this.loadStreams();

	}

	componentWillUnmount() {
	}

	async loadStreams() {
		let params = new URLSearchParams();
		const x = await postApi('/v3/support/streams', params);
		console.log(x.data);
		if( x.status === 200 ) this.setState({status: true, streams: x.data.streams});
	}

	

	render() {
		
		const streams = this.state.streams.map((e,i) => {
			return (
				<Col xs={12} lg={6} key={i}>
					<div className="card">
						<div className="card-header">
							{e.server}
						</div>
						<div className="card-body">
						<VideoPlayer
							id="video"
							//service={this.state.service.id} //{this.state.select.address}
							//select={this.state.select_temp.select}
							//uid={this.state.stage.live?.uid}
							//theatre={this.theatre}
							onError={()=>{}}
							//height={this.state.meta?.video?.height}
							url={e.address}
							autoPlay={false}
							controls={true}
							
						/>
						</div>
						<div className="card-footer">
							{e.subdomain}/{e.streamurl.replace('./','')}
						</div>
					</div>
					
				</Col>
			)
		});
		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">System</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">System</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>
									
									<Col xs={12}>
										<div className="row row-cols-xxl-5 row-cols-xl-3 row-cols-md-2">
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Sales</p>
																<h3 className="mb-0">$18,645</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-primary-transparent ms-auto">
																<i className="bi bi-cart-check fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-primary-transparent rounded-pill">+24% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Revenue</p>
																<h3 className="mb-0">$34,876</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-secondary-transparent ms-auto">
																<i className="bi bi-archive fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+0.26% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Total Products</p>
																<h3 className="mb-0">26,231</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-info-transparent ms-auto">
																<i className="bi bi-handbag fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+06% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Expenses</p>
																<h3 className="mb-0">$73,579</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-warning-transparent ms-auto">
																<i className="bi bi-currency-dollar fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-success-transparent rounded-pill">+10% <i className="fe fe-arrow-up"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Active Subscribers</p>
																<h3 className="mb-0">1,468</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-danger-transparent ms-auto">
																<i className="bi bi-bell fs-20"></i>
															</div>
														</div>
														<div className="d-flex mt-2">
															<span className="badge bg-danger-transparent rounded-pill">+16% <i className="fe fe-arrow-down"></i></span>
															<a href="javascript:void(0);" className="text-muted fs-11 ms-auto text-decoration-underline mt-auto">view more</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										<Row className="gx-0">
											{streams}
										</Row>
										
									</Col>
									
								</Row>
							</div>
						</div>
					</div>
				}
			</>
		);
	}
}
